export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/store/modals/modal-reassign-adviser-v2.store.ts"